import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Button } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { tokenManager } from '../../../REST';
import { useIsMobile, useProfile, useRouterStore } from '../../../hooks';
import { disableUserImpersonation, setUiInitPageList } from '../../../middleware';
import Styles from './m_styles.less';

export const ImpersonateTopBar: React.FC = observer(() => {
    const { firstName, lastName } = useProfile();
    const routerStore = useRouterStore();
    const isMobile = useIsMobile();

    const handleDisableImpersonation = async () => {
        const { isError } = await disableUserImpersonation();

        if (!isError) {
            await tokenManager.disableImpersonatedToken();
        }
    };

    const handleGoToImpersonatePage = async () => {
        await routerStore.goTo('ImpersonateUser');
    };

    useEffect(() => {
        return () => {
            setUiInitPageList();
            handleGoToImpersonatePage();
        };
    }, []);

    return firstName && lastName ? (
        isMobile ? (
            <WarningOutlined className={Styles.iconWarning} onClick={handleDisableImpersonation} />
        ) : (
            <Button icon={<WarningOutlined />} danger ghost onClick={handleDisableImpersonation}>
                {`Disable impersonation as ${firstName} ${lastName} !`}
            </Button>
        )
    ) : (
        <span>Loading...</span>
    );
});
